import {Ref, ref, computed} from '@vue/composition-api';
import {LunchTime} from './types';

export const useMealToggle = (category: Ref<string>, diningCategory = 'DINING') => {
  const selectedLunchTime = ref<LunchTime>(LunchTime.NONE);

  const getSelectedLunchTime = (): Readonly<LunchTime> => {
    return selectedLunchTime.value;
  };

  const isMealSelected = computed(() => {
    return category.value === diningCategory;
  });
  // const isLunchActive = computed(() => {
  //   return selectedLunchTime.value === LunchTime.MORNING;
  // });
  // const isDinnerActive = computed(() => {
  //   return selectedLunchTime.value === LunchTime.AFTERNOON;
  // });
  const isMorningActive = computed(() => {
    return selectedLunchTime.value === LunchTime.MORNING;
  });
  const isAfternoonActive = computed(() => {
    return selectedLunchTime.value === LunchTime.AFTERNOON;
  });
  const isEveningActive = computed(() => {
    return selectedLunchTime.value === LunchTime.EVENING;
  });
  const isNightActive = computed(() => {
    return selectedLunchTime.value === LunchTime.NIGHT;
  });
  const isAnyMealActive = computed(() => {
    return selectedLunchTime.value === LunchTime.ANY;
  });
  const onMealChange = (value: LunchTime) => {
    selectedLunchTime.value = value;
  };

  return {
    isMealSelected,
    // isLunchActive,
    // isDinnerActive,
    isEveningActive,
    isMorningActive,
    isAfternoonActive,
    isNightActive,
    isAnyMealActive,
    onMealChange,
    //   selectedLunchTime,
    getSelectedLunchTime,
  };
};
